export default __webpack_public_path__ + "static/media/angular.3075084c.svg";